/**
 * Returns a same-origin path safe for router navigation, or null if untrusted.
 * Blocks open redirects (absolute URLs, protocol-relative paths, schemes like javascript:).
 */
export function getSafeInternalReturnUrl(
  raw: string | string[] | undefined
): string | null {
  const value =
    typeof raw === 'string'
      ? raw
      : Array.isArray(raw) && typeof raw[0] === 'string'
        ? raw[0]
        : '';

  if (!value) return null;

  let path = value.trim();
  try {
    path = decodeURIComponent(path);
  } catch {
    return null;
  }
  path = path.trim();

  if (!path.startsWith('/')) return null;
  if (path.startsWith('//')) return null;
  if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(path)) return null;
  if (path.includes('\\')) return null;
  if (path.length > 2048) return null;

  return path;
}
